import { render } from "./IndexPaymentCenterHome.vue?vue&type=template&id=201fe5be"
import script from "./IndexPaymentCenterHome.vue?vue&type=script&lang=js"
export * from "./IndexPaymentCenterHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__